<template>
    <div class="home">
        <Headerd/>
        <!--首页-->
        <Cont v-on:childByBtn="childByBtn"></Cont>
<!--        &lt;!&ndash;测试视频&ndash;&gt;-->
<!--        <div class="container">-->
<!--            <div class="block">-->
<!--                <span class="demonstration">年</span>-->
<!--                <el-date-picker-->
<!--                        v-model="value5"-->
<!--                        type="year"-->
<!--                        placeholder="选择年"-->
<!--                        @blur="cloo">-->
<!--                </el-date-picker>-->
<!--            </div>-->
<!--        </div>-->
        <!--模块服务-->
        <service-m v-on:childByBtn="childByBtn"></service-m>
        <!--律师风采-->
        <lawyer-s/>
        <!--服务范围-->
        <service-s/>
        <!--法律讲座-->
        <Lecture/>
        <!--服务套餐-->
        <ServiceP v-on:childByBtn="childByBtn"></ServiceP>
        <!--关于我们-->
        <About/>
        <div class="mengBan" v-show="isShow">
            <div class="inputDiv" v-show="isShow">
                <div class="successImg" v-show="inShow">
                    <div class="image">
                        <img src="../assets/img/激活成功.png">
                        <span>
                        <p>恭喜您提交成功,</p>
                        <p>稍后将有专属人员与您联系</p>
                    </span>
                        <el-button @click="SubmiOk" type="primary">确定</el-button>
                    </div>

                </div>
                <div class="con" v-show="!inShow">
                    <div class="cont">
                        <div class="conName">
                            <span style="float: left;line-height: 40px;color: red">*</span>
                            <el-input style="width: 480px" v-model="InpList.iname" placeholder="姓名" @blur="chunkName"></el-input>
                        </div>
                        <div class="conPhone">
                            <span style="float: left;line-height: 40px;color: red">*</span>
                            <el-input style="width: 480px" v-model="InpList.iphone" placeholder="手机号" @blur="chunkPhone"></el-input>
                        </div>
                    </div>
                    <div class="conNeed">
                        <el-input
                                style="width: 480px"
                                type="textarea"
                                :rows="8"
                                maxlength="200"
                                placeholder="请简单描述您所需要的法律需求，稍后将有专属人员与您联系。"
                                v-model="InpList.itxt">
                        </el-input>
                        <p style="float: right;padding-right: 10px;padding-top: 10px;font-size: 12px">“ <span style="color: red">*</span> ”为必填项</p>
                    </div>
                    <el-button @click="Submission" type="primary">立即提交</el-button>
                    <el-button @click="Submi" type="primary">取消</el-button>
                </div>
            </div>
        </div>
        <div class="topHome" @click="homePage"></div>
    </div>
</template>

<script>
    import qs from 'qs';
    import Headerd from '../components/headerd';
    import Cont from '../components/cont';
    import ServiceM from '../components/serviceM'
    import LawyerS from '../components/lawyerS'
    import serviceS from '../components/serviceS'
    import Lecture from '../components/lecture'
    import ServiceP from  '../components/serviceP'
    import About from '../components/about'
    export default {
        name: "home",
        components:{
            Headerd,
            Cont,
            ServiceM,
            LawyerS,
            serviceS,
            Lecture,
            ServiceP,
            About
        },
        data(){
            return{
                value5:'2019',
                isShow : false,
                inShow:false,
                i:0,
                reg:/^1[3|4|5|7|8][0-9]{9}$/,
                chunkReg:false,
                chunkNae:false,
                InpList:{
                    iname:'',
                    iphone:'',
                    itxt:''
                }
            }
        },
        mounted(){
            window.addEventListener('scroll', this.handleScroll, true);
        },
        methods:{
            cloo(){
                console.log(this.value5)
            },
            chunkPhone(){
                if(!(this.reg.test(this.InpList.iphone))){
                    this.chunkReg = false;
                }else {
                    this.chunkReg = true;
                }
            },
            chunkName(){
                if(!this.InpList.iname==""){
                    this.chunkNam = true;
                    // console.log("请重填2");
                }else {
                    this.chunkNam = false;
                    // console.log("请重填1");
                }
            },
            childByBtn:function (childByBtn) {
                this.isShow = childByBtn;
                // console.log(childByBtn+"!!!!!!!!");
                this.isShow = !this.isShow;
            },

            Submission(){

                // console.log(this.InpList.iname+this.InpList.iphone+this.InpList.itxt)
                if(this.chunkReg == true && this.chunkNam == true){
                    //this.inShow = !this.inShow;
                    this.inShow = !this.inShow;
                    this.$axios.post('gdfwzixun',qs.stringify({
                        name:this.InpList.iname,
                        mobile:this.InpList.iphone,
                        detail:this.InpList.itxt
                    })).then(function (res) {
                        console.log(res);
                    }).catch(function (error) {
                        console.log(error)
                    });
                    this.InpList.iname = "";
                    this.InpList.iphone = "";
                    this.InpList.itxt = "";
                } else if(this.chunkReg == true && this.chunkNam == false){
                    this.$alert('请输入您的姓名', '温馨提示', {
                        confirmButtonText: '确定',
                    });
                } else if(this.chunkReg == false && this.chunkNam == true){
                    this.$alert('手机号输入有误', '温馨提示', {
                        confirmButtonText: '确定',
                    });
                } else {
                    this.$alert('请填写必要信息，以方便我们与您联系', '温馨提示', {
                        confirmButtonText: '确定',
                    });

                };

            },
            Submi(){
                this.isShow = !this.isShow;
                this.InpList.iname = "";
                this.InpList.iphone = "";
                this.InpList.itxt = "";
            },
            SubmiOk(){
                this.inShow = !this.inShow;
                this.isShow = !this.isShow;
            },
            homePage(){
                document.querySelector(".banner").scrollIntoView(true);
                // console.log("首页")
            },
            handleScroll() {
                // 页面滚动距顶部距离
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
                    document.body.scrollTop
                var scroll = scrollTop - this.i;
                // console.log(scroll);
                this.i = scrollTop;

                if (scrollTop > 500) {
                    let topHome = document.querySelector(".topHome");
                    topHome.style.display = "block";
                }else {
                    let topHome = document.querySelector(".topHome");
                    topHome.style.display = "none";
                }
                if (scroll < 0) {
                    // console.log('up')
                    let headerd = document.querySelector(".header_con");
                } else {
                    // console.log('down')
                    let headerd = document.querySelector(".header_con");
                    headerd.style.backgroundColor = "rgb(40,43,47)";
                }
            }
        },
    }
</script>

<style lang="less" scoped>
    .home{
        height: 100%;
        .headerd{
            position: fixed;
            top: 0;
            left: 0;
            z-index: 10000;
        }
        .mengBan{
            width: 100%;
            height: 100%;
            position: fixed;
            z-index: 100;
            left: 0;
            top: 0;
            background: rgba(0,0,0,0.3);
            .inputDiv{
                position: absolute;
                left: 50%;
                top:50%;
                margin-top: -229px;
                margin-left: -275px;
                z-index: 100000;
                width: 550px;
                height: 458px;
                background: white;
                box-shadow: 0 5px 21px 0 rgba(3,20,58,0.14);
                display: flex;
                justify-content: center;
                align-items: center;
                .successImg{
                    width:100%;
                    height:100%;
                    .image{
                        text-align:center;
                        width:214px;
                        height:300px;
                        padding-top:60px;
                        padding-left:168px;
                        span{
                            display:block;
                            margin-top:20px;
                            text-align:center;
                            font-size:16px;
                            margin-bottom:60px;
                            p{
                                line-height:25px;
                            }
                        }
                    }

                }
                .con{
                    text-align: center;
                    width: 500px;
                    height: 400px;
                    .cont{
                        width: 100%;
                        .conName{
                            width: 500px;
                            .el-input__inner{
                                border-radius: 0;
                            }
                        }
                        .conPhone{
                            padding-top: 20px;
                            width: 500px;
                            height: 68px;
                            float: right;
                            .el-input__inner{
                                border-radius: 0;
                            }
                        }
                    }
                    .conNeed{
                        width: 100%;
                        height: 250px;
                        padding-bottom: 50px;
                    }
                    .el-textarea__inner{
                        border-radius: 0;
                    }
                }
            }
        }

        .topHome{
            display: none;
            width: 50px;
            height: 50px;
            background: url("../assets/img/返回顶部.png") no-repeat;
            background-size: cover;
            position: fixed;
            z-index: 100;
            bottom: 0;
            right: 0;
        }
        .el-button:nth-child(3){
            width:150px;
            height:50px;
            border-radius:8px;
            color:white;
            background:rgb(50,150,250);
            font-size:14px;
            font-weight:550;
        }
        .el-button:nth-child(4){
            width:150px;
            height:50px;
            border-radius:8px;
            color:#999;
            background:white;
            font-size:14px;
            font-weight:550;
            border-color:#dcdfe6;
        }
    }

</style>



// WEBPACK FOOTER //
// src/view/home.vue